import React, { Component } from "react";

import "./style.css";
import Logo from '../../../assets/images/notifyi-logo-solid-light.png'
import PropTypes from "prop-types";

import Drawer from 'material-ui/Drawer';
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider"

class SideBar extends Component {

  state = { 
    vWidth: null
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    this.setState({ vWidth: window.innerWidth });
  }

  render() {
    const {
      isOpen,
      handleRequestChange,
      routePage,
      updateRoutePage
    } = this.props

    const { vWidth } = this.state

    return (
      <MuiThemeProvider>
        <Drawer
          className="dash-sidebar"
          open={isOpen}
          docked={vWidth >= 980 ? true : false}
          onRequestChange={(open) => handleRequestChange(open)}
        >
          <section className="dash-logo" style={{ padding: '20px 16px' }}>
            <figure>
              <img src={Logo} alt="logo" />
            </figure>
          </section>
          <div className={`dash-sidebar__item ${routePage === 'dashboard' && 'active'}`} onClick={() => updateRoutePage('dashboard')}>
            <i className="icon-grid dash-sidebar__icon" />
            Dashboard
          </div>
          <div className={`dash-sidebar__item ${['users', 'user-form'].includes(routePage) && 'active'}`} onClick={() => updateRoutePage('users')}>
            <i className="icon-user dash-sidebar__icon" />
            Users
          </div>
          <div className={`dash-sidebar__item ${routePage === 'students' && 'active'}`} onClick={() => updateRoutePage('students')}>
            <i className="icon-people dash-sidebar__icon" />
            Students
          </div>
          <div className={`dash-sidebar__item ${['admn-alerts', 'admn-alert-details'].includes(routePage) && 'active'}`} onClick={() => updateRoutePage('admn-alerts')}>
            <i className="icon-info dash-sidebar__icon" />
            Admission Alerts
          </div>
          <div className={`dash-sidebar__item ${['scholarship-alerts', 'scholarship-alert-details', 'new-scholarship-alerts'].includes(routePage) && 'active'}`} onClick={() => updateRoutePage('scholarship-alerts')}>
            <i className="icon-badge dash-sidebar__icon" />
            Scholarship Alerts
          </div>
          <div className={`dash-sidebar__item ${['careers', 'career-details', 'new-career'].includes(routePage) && 'active'}`} onClick={() => updateRoutePage('careers')}>
            <i className="icon-eyeglass dash-sidebar__icon" />
            Careers
          </div>
          <div className={`dash-sidebar__item ${['university', 'university-form'].includes(routePage) && 'active'}`} onClick={() => updateRoutePage('university')}>
            <i className="icon-graduation dash-sidebar__icon" />
            Universities
          </div>

          {/* NEW: School Code */}
          <div
            className={`dash-sidebar__item ${['school-code','school-code-form'].includes(routePage) && 'active'}`}
            onClick={() => updateRoutePage('school-code')}
          >
            <i className="icon-key dash-sidebar__icon" />
            School Code
          </div>

          <div className={`dash-sidebar__item mb-3 ${routePage === 'advertisement' && 'active'}`} onClick={() => updateRoutePage('advertisement')}>
            <i className="icon-picture dash-sidebar__icon" />
            Live Advertisement
          </div>
        </Drawer>
      </MuiThemeProvider>
    )
  }
}

export default SideBar;



/** WEBPACK FOOTER **
 ** ./src/components/Admin/SideBar/index.js
 **/